import { RouteConfig } from "vue-router";
import ROUTES from "../routes";
import { hasFeature } from "src/js/stores/user/actions";
import { Feature } from "src/js/stores/user";

export const MapRoutes: Array<RouteConfig> = [
  {
    path: "/map/:z?,:x?,:y?",
    component: () =>
      import(
        /* webpackChunkName: 'map' */
        /* webpackPreload: true */
        "../../view/map/map.vue"
      ),
    name: ROUTES.MAP,
  },
  {
    path: "/map",
    redirect: { name: ROUTES.MAP },
  },
  {
    path: "/legacy-search/:z?,:x?,:y?",
    component: () =>
      import(
        /* webpackChunkName: 'legacySearch' */
        /* webpackPreload: true */
        "../../view/map/map.vue"
      ),
    name: ROUTES.LEGACY_SEARCH,
  },
  {
    path: "/legacy-search",
    redirect: { name: ROUTES.LEGACY_SEARCH },
  },
  {
    path: "/search/:z?,:x?,:y?",
    name: ROUTES.SEARCH,
    beforeEnter: (_from, _to, next) => {
      if (hasFeature(Feature.multiFilterSearch)) next();
      else next({ name: ROUTES.MAP });
    },
    component: () =>
      import(
        /* webpackChunkName: 'search' */
        /* webpackPreload: true */
        "../../view/wrappers/search/search.vue"
      ),
  },
];
